module.exports = __webpack_public_path__ + "media/images/game_icon/en/AB1503-27a2cfce784aa6989b87fc402e42adc6.png";